import { type FC } from "react";
import { SymbolIcon, TriggerButton, TriggerButtonGroup, TriggerButtonIntent } from "widgets";
import { useDataAttributes } from "widgets/hooks";

interface ToggleFiltersButtonProps {
  areFiltersVisible: boolean;
  toggleFiltersVisibility: () => void;
}
export const ToggleFiltersButton: FC<ToggleFiltersButtonProps> = ({
  areFiltersVisible,
  toggleFiltersVisibility,
  ...props
}) => {
  const dataAttributes = useDataAttributes(props);

  return (
    <TriggerButtonGroup key="toggle-filters">
      <TriggerButton
        {...props}
        icon={
          <span style={{ display: "contents" }}>
            <SymbolIcon
              icon={areFiltersVisible ? "filter_alt_off" : "filter_alt"}
              style={areFiltersVisible ? { color: "var(--primary-main)" } : undefined}
              filled={areFiltersVisible}
            />
            <SymbolIcon
              icon={areFiltersVisible ? "keyboard_arrow_up" : "keyboard_arrow_down"}
              style={{
                color: areFiltersVisible ? "var(--primary-main)" : undefined,
                position: "absolute",
                top: areFiltersVisible ? 7 : 10,
                right: 0,
              }}
              size={14}
            />
          </span>
        }
        label={areFiltersVisible ? "Reset Filters" : "Show Filters"}
        // badge={isFilterActive}
        onPress={toggleFiltersVisibility}
        intent={areFiltersVisible ? TriggerButtonIntent.Active : undefined}
        {...dataAttributes}
      />
    </TriggerButtonGroup>
  );
};
